'use strict';

import React, { Component, useState, useEffect, useCallback, useRef, useDebugValue, useContext } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import { findTransporterByCode } from "./sobTransporterLookup";
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import Showlmvalue from "./showlmvalue";
import { verifyext, verifycsvdata } from "../common/verifyext";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { Edit, Trash } from 'lucide-react';
import AddEditController from './addEditController.js';
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmShareOfBusiness extends Component {
    static contextType = LoadingPortContext;

    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : null;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
                resizable: true
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                Showlmvalue: Showlmvalue
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-m",
            loadshow: "show-m",
            trnsportersList: [],
            statesList: [],
            vehicleList: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            transdata: [],
            zonesList: [],
            zoneStates: [],
            sliderType: 1,
            comp_code: "",
            lpNames: [],
            loading_port_code: "",
            filter_start_date: "",
            filter_end_date: "",
            valid_from: "",
            valid_to: "",
            data_valid_from: "",
            data_valid_to: "",
            data_type: 1,
            regularActive: "activet", hubActive: "",
            truckActive: "",
            courierActive: "", airCourierActive: "", showBulkSlider: false, errors: [], overErrors: [], validData: [],
            pinnedRegionBottomRowData: [], editHubSOB: { open: false, data: [], total: 0, hub: "" }
            //components : {datepicker:getDatePicker()}
        }
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        this.onCellClicked = this.onCellClicked.bind(this)
        this.onLoadShowData = this.onLoadShowData.bind(this);
        this.assignCheckRef = React.createRef();
        this.createColumns = this.createColumns.bind(this);
        this.createRows = this.createRows.bind(this);
        this.checkFileData = this.checkFileData.bind(this);
        this.fileInputRef = React.createRef();
        this.totalDataRef = React.createRef();
        // this.createRows = this.createRows.bind(this);

    }

    async componentDidMount() {
        loadDateTimeScript();
        var currentDate = moment.parseZone().format("YYYY-MM-DD");
        //console.log(currentMonth,"currentMonth")
        await this.setState({
            filter_start_date: currentDate
        })
        await this.pageAccess();
    }
    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = this.props.match.path;
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            // No access (already alerted+redirected), empty port list, or a logged request error.
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.onLoadShowData();
    }
    onLoadShowData = async () => {
        this.setState({
            overly: "show-m",
            loadshow: "show-m",
        })
        var filter_start_date = this.state.filter_start_date;
        var filter_end_date = this.state.filter_end_date;
        var loading_port_code = this.state.loading_port_code;
        var data_type = this.state.data_type;
        var params = {
            loading_port_code: loading_port_code,
            data_type: data_type, hub_transporter: 0, is_hub: 0,
            filter_start_date: filter_start_date,
            filter_end_date: filter_end_date,
            air_courier_transporter: this.state.airCourierActive == "activet" ? 1 : 0,
            is_air_courier: this.state.airCourierActive == "activet"
        }
        await redirectURL.post("/lmconsignees/getLmShareOfBusiness", params).then((response) => {
            console.log(response.data.sobData.length, "length");
            console.log(response.data.sobCount, "totalCount");
            var data_valid_from = "";
            var data_valid_to = "";
            if (response.data.sobData.length > 0) {
                data_valid_from = response.data.sobData[0].valid_from;
                data_valid_to = response.data.sobData[0].valid_to;
            }
            this.setState({
                transdata: response.data.sobData,
                data_valid_from: data_valid_from,
                data_valid_to: data_valid_to,
            })
        }).catch((e) => {
            console.log(e);
        })

        await redirectURL.post('/lmconsignees/prtUniqueTransportersListWithNames', params)
            .then((response) => {
                //console.log(response.data);
                var transporters = response.data;
                // var trnsportersList = [];
                // if(transporters.length > 0)
                // {
                //     transporters.map((item) =>{
                //         trnsportersList.push(item)
                //     })
                // }
                this.setState({
                    trnsportersList: transporters.filter((each) => each.transporter_code != ""),
                })
            })
            .catch(function (error) {
                console.log(error)
            });

        await redirectURL.post("/lmconsignees/getLmSobZones", params).then((response) => {
            var zones = response.data;
            this.setState({
                zonesList: zones,
            })
        }).catch((e) => {
            console.log(e);
        })

        await redirectURL.post("/lmconsignees/getLmSobUniqueZones", params).then((response) => {
            var statesList = response.data;
            this.setState({
                statesList: statesList,
            })
        }).catch((e) => {
            console.log(e);
        })

        await this.createColumns();
        await this.createRows();



        this.setState({
            overly: "show-n",
            loadshow: "show-n"
        })
        // redirectURL.post("/lmconsignees/getLmVehicleCapacity").then((response)=>{
        //     var lmvehs = response.data;
        //     var vehicleList = [];
        //     if(lmvehs.length > 0)
        //     {
        //         lmvehs.map((item) =>{
        //             vehicleList.push(item.vehicle_cap)
        //         })
        //     }
        //     this.setState({
        //         vehicleList : vehicleList,
        //     })
        // }).catch((e)=>{
        //     console.log(e);
        // })
    }

    createColumns() {

        var transporters = this.state.trnsportersList;
        var states = this.state.statesList
        var columns = []
        columns.push({
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 230,
            editable: false
        })
        columns.push({
            headerName: "Transporter Code",
            field: "transporter_code",
            width: 180,
            editable: false
        })
        states.map((trans) => {
            console.log("trans ", trans)
            var defs = {}
            transporters.map((ste) => {
                //  console.log("ste ", ste)

                var ss = trans
                defs.headerName = trans;
                defs.field = ss;
                defs.width = 190;
                defs.editable = false;
                defs.cellRendererFramework = (params) => {

                    if (Array.isArray(params.value) && params.value.length > 0) {
                        return (
                            <>
                                <span
                                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => {
                                        var zonesList = this.state.zonesList;
                                        var zoneStates = zonesList.filter((e) => e.zone == params.colDef.headerName);
                                        // console.log(zonesList, "zonesList")
                                        console.log(zoneStates, "zoneStates", params.colDef.headerName)
                                        this.setState({
                                            zoneStates: [{ state: params.colDef.headerName }, ...zoneStates],
                                            bulkslide: true, overly: "show-m"
                                        })
                                    }}
                                >
                                    {params.value[0]}
                                </span>
                                <span className="ml-3"
                                    style={{ color: "green", cursor: "pointer", textDecoration: "underline", cursor: this.assignCheckRef.current && "not-allowed", opacity: this.assignCheckRef.current && "0.5" }}
                                    onClick={() => {
                                        !this.assignCheckRef.current &&
                                            this.handleEditHubSOB(params.colDef.headerName)
                                    }}
                                    disabled={this.assignCheckRef.current}
                                >
                                    {params.value[1]}
                                </span>
                            </>
                        );
                    }
                    return params.value || 0;
                }

            })


            columns.push(defs)
        })
        console.log("Columns ", columns)
        this.setState({
            columnwithDefs: columns,
            overly: "show-n",
            loadshow: "show-n",
        })
    }

    handleEditHubSOB = (hub) => {
        // console.log(totalDataRef.current, hub)
        // Snapshot the current values before any edits are made, so we can detect "no changes" on submit.
        var originalValues = this.totalDataRef.current.map((row) => ({
            transporter_code: row.transporter_code,
            value: parseFloat(row[hub]) || 0
        }));
        this.setState({
            editHubSOB: {
                open: true,
                hub: hub,
                data: this.totalDataRef.current,
                originalValues: originalValues,

                total: this.totalDataRef.current.reduce((sum, row) => sum + (Number(row[hub]) || 0), 0)
            }, overly: "show-m"
        })
    }

    async createRows() {
        var statesList = this.state.statesList;
        var transporters = this.state.trnsportersList;
        var transdata = this.state.transdata;
        var rowdefs = []
        await transporters.map((ste) => {
            var rows = {}
            rows.transporter_name = ste.transporter_name;
            rows.transporter_code = ste.transporter_code;
            if (transdata.length > 0) {
                var transportername = groupBy(transdata, rdata => rdata.zone);
                transportername.forEach((trans, transkey) => {
                    trans.map((t) => {
                        //console.log("Here t ", t)
                        rows["zone"] = transkey;
                        if (t.transporter_code == ste.transporter_code) {
                            rows[t.zone] = t.sob
                            // rows["transporter_value"] = t.sob;
                        }


                    })

                })
            }
            rowdefs.push(rows)
        })
        console.log(transdata, rowdefs)
        //console.log("rowdefs ", rowdefs)
        var pinnedBottomRowData = {}
        var temp = {};
        if (rowdefs.length > 0) {
            var gridkeys = Object.keys(rowdefs[0]);
            statesList.map(function (e) {
                temp[e] = 0
            })
        }
        else {
            var gridkeys = [];
        }
        gridkeys = gridkeys.filter(function (e) { return e == "transporter_name" && e != "transporter_code" && e != "zone" })
        rowdefs.map(function (e, index) {
            statesList.map(function (k) {
                if (e[k] != undefined && e[k] != "") {
                    //console.log(k,e[k],"temp[k]")
                    temp[k] = temp[k] + parseFloat(e[k]);
                }
            })
        })
        temp['transporter_name'] = "Total";
        temp['transporter_code'] = "Total";
        //console.log(temp,"temp")

        var zoneDetails = {};
        zoneDetails.transporter_name = "";
        zoneDetails.transporter_code = "";
        statesList.map(function (s) {
            zoneDetails[s] = ["View States", "Edit"];
        });
        // rowdefs.push(zoneDetails)
        this.totalDataRef.current = [...rowdefs];
        this.setState({
            rowData: rowdefs,
            pinnedRegionBottomRowData: [zoneDetails, temp],
            overly: 'show-n',
            load: 'show-n',
        })
    }
    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
        var sort = [
            {
                colId: 'transporter_name',
                sort: 'asc',
            },
        ];
        this.gridApi.setSortModel(sort);
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }




    closeAlert = async () => {
        await this.setState({
            show: false
        });
        await window.location.reload();
    }

    onCellClicked(e) {
        //console.log(e);
        if (e.value == "View States") {
            var zone = e.colDef.field;
            if (zone != undefined && zone != '') {
                var zonesList = this.state.zonesList;
                var zoneStates = zonesList.filter(function (e) { return e.zone == zone });
                console.log(zonesList, "zonesList")
                console.log(zoneStates, "zoneStates")
                $(".subH").html(zone + " States");
                this.setState({
                    sliderType: 2,
                    zoneStates: zoneStates,
                    overly: "show-m",
                    bulkslide: "slider-translate"
                })
            }
        }
    }

    onCellUpdateData = (params) => {
        // console.log("Params ", params)
        var statesList = this.state.statesList
        var clickedField = params.colDef.field;
        // var colData = params.data;
        // var objects = Object.keys(colData);
        var rowTotal = 0;
        // objects.map(function(e){
        //     if(parseInt(params.data[e]).toString() != "NaN")
        //     {
        //         rowTotal = parseInt(rowTotal)+parseInt(params.data[e]); 
        //     }
        // })
        var allrows = []
        this.gridApi.forEachNode((node, index) => {
            //console.log("node ",node)
            allrows.push(node.data)
        })
        allrows.map(function (e) {
            if (parseInt(e[clickedField]).toString() != "NaN") {
                rowTotal = parseInt(rowTotal) + parseInt(e[clickedField]);
            }
        })
        if (parseInt(rowTotal) > parseInt(100)) {
            // console.log(rowTotal,"rowTotal")
            this.setState({
                show: true,
                basicType: "warning",
                basicTitle: "Share Of Business Should not be greater than 100%"
            });
            var currentField = params.colDef.field;
            params.data[currentField] = 0
        }

        var pinnedBottomRowData = {}
        var temp = {};
        // console.log(allrows,"allrows")
        if (allrows.length > 0) {
            var gridkeys = Object.keys(allrows[0]);
            statesList.map(function (e) {
                temp[e] = 0
            })
        }
        else {
            var gridkeys = [];
        }
        gridkeys = gridkeys.filter(function (e) { return e != "transporter_name" && e != "transporter_code" && e != "zone" })
        gridkeys.map(function (k) {
            allrows.map(function (e, index) {
                if (e[k] != undefined && e[k] != "" && e[k] != "View States") {
                    // console.log(k,e[k],"temp[k]")
                    temp[k] = temp[k] + parseFloat(e[k]);
                }
            })
        })
        temp['transporter_name'] = "Total";
        temp['transporter_code'] = "Total";
        // console.log(temp,"temp")
        this.setState({
            pinnedRegionBottomRowData: [temp],
        })
        this.gridApi.refreshCells();
    }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            zoneStates: [],
            sliderType: 1,
            bulkslide: false,
            valid_from: "",
            valid_to: "",
            showBulkSlider: false, fileName: "",
            editHubSOB: { open: false, hub: "", data: [], total: 0 },
            errors: [],
            overErrors: [], rowErrors: []
        });

    }
    updateLmStates(params) {
        //console.log(params);
        if (params.transporter_name != '' && params.transporter_name != undefined && params.state != '' && params.state != undefined && params.sob != '' && params.sob != undefined) {
            params.data_type = this.state.data_type;
            redirectURL.post("/lmconsignees/savelmshareofbusiness", params).then((response) => {
                console.log(response);
                if (response.data.message == "Success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    window.location.reload();
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true
            })
        }
    }
    addNewRow() {
        // console.log(this.gridApi);
        this.gridApi.insertItemsAtIndex(0, [{ transporter_name: "", state: "", sob: "" }])
        // this.gridApi.updateRowData({add:[{holiday_date:"",holiday_name:""}]});
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }
    onClickDataExport() {
        var params = {
            fileName: "approved_sob_percentage.csv"
        };
        this.gridApi.exportDataAsCsv(params);
    }
    showBulkUpload() {
        $(".subH").html("Bulk Upload");
        this.setState({
            overly: "show-m",
            showBulkSlider: true,
            errors: [],
            overErrors: [],
            validData: [],
            fileName: ""
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            zoneStates: [],
            sliderType: 1,
            overly: 'show-n',
            file: ''
        });
        document.getElementById("upform").reset();
    }
    changeFileHandler = async (e) => {
        var dt = '';
        const config = {
            headers: [
                {
                    name: 'Transporter Name',
                    inputName: 'transporter_name',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Transporter Code',
                    inputName: 'transporter_code',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Zone',
                    inputName: 'zone',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Approved SOB',
                    inputName: 'sob',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
            ]
        }
        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                this.setState({
                    csvData: csvData.data
                });
                console.log(csvData.data);
            })
            .catch(err => { })
        // console.log("e.target.files[0]",e.target.result);

        var out = new Promise(function (reject, resolve) {
            var reader = new FileReader();
            reader.onload = async function (e) {
                var contents = await e.target.result;
                resolve(contents);
            };
            var tt = reader.readAsText(e.target.files[0]);
        });
        this.setState({
            file: e.target.files[0]
        });
        // console.log("e.target.files[0].type ", e.target.files[0]);
        var check = verifyext(e.target.files[0].name);
        //console.log("Check ", check)
        if (check == true) {
            if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))

            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }

    }

    checkFileData() {

        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == 0) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
    }
    uploadBulkFormHandler(event) {
        event.preventDefault();
        var fileData = this.state.csvData;
        var flag = 0;
        console.log(fileData, "fileData");
        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        // console.log("verifycsvdata ", vdata)
        if (vdata == true) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
        else {
            if (flag == 0) {
                if (fileData.length > 0) {
                    var valid_from = this.state.valid_from;
                    var valid_to = this.state.valid_to;
                    if (valid_from != undefined && valid_from != '' && valid_to != undefined && valid_to != '') {
                        var reqParams = {
                            loading_port_code: this.state.loading_port_code,
                            valid_from: valid_from,
                            valid_to: valid_to,
                            csvData: fileData,
                            data_type: this.state.data_type,
                            updated_by: localStorage.getItem("email")
                        }
                        console.log("reqParams", reqParams)
                        redirectURL.post("/lmconsignees/savebulklmapprovedsob", reqParams).then((response) => {
                            var resp = response.data.message;
                            console.log(resp)
                            this.setState({
                                basicTitle: resp,
                                basicType: "success",
                                show: true,
                                bulkslide: '',
                                overly: 'show-m',
                                load: 'show-m',
                            })
                            this.onLoadShowData();
                            //window.location.reload();
                        }).catch((e) => {
                            console.log(e);
                        })
                    }
                    else {
                        this.setState({
                            basicTitle: "Select Valid From & Valid to",
                            basicType: "warning",
                            show: true,
                        })
                    }
                }
                else {
                    this.setState({
                        basicTitle: "Invalid File",
                        basicType: "warning",
                        show: true,
                    })
                }
                $('#upform')[0].reset();
            }
            else {
                $("#bulkUploadID").val();
                this.setState({
                    basicTitle: "Fields Should not be Empty",
                    basicType: "warning",
                    show: true,
                })
                $('#upform')[0].reset();
            }
        }
    };




    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    updateGridData() {
        var allrows = []
        this.gridApi.forEachNode((node, index) => {
            //console.log("node ",node)
            allrows.push(node.data)
        })
        //console.log("allrows ", allrows)
        var records = []
        if (allrows.length > 0) {
            allrows.forEach((item) => {
                //console.log("item ", item)
                var row = {}
                row.transporter_code = item.transporter_code
                row.transporter_name = item.transporter_name
                var zones = []
                for (var x in item) {
                    //console.log("Item key ", x)
                    if (x == "transporter_name" || x == "zone" || x == "transporter_code") {
                    }
                    else {
                        zones.push({
                            "zone": x,
                            "sob": parseFloat(item[x])
                        })
                    }
                }
                row.zones = zones
                records.push(row)
            })
        }
        console.log("records ", records)
        var loading_port_code = this.state.loading_port_code;
        var data_type = this.state.data_type;
        var parameters = {
            records: records,
            loading_port_code: loading_port_code,
            data_type: data_type,
            data_valid_from: this.state.data_valid_from,
            data_valid_to: this.state.data_valid_to,
        }
        redirectURL.post("/lmconsignees/updateLmShareBusiness", parameters)
            .then((response) => {
                console.log(response);
                if (response.data.message == "success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    this.onLoadShowData()
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
    }

    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange();
        }
    }
    onGlobalPortChange = async () => {
        var selectedPlant = this.context.loading_port_code;
        if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection, don't refetch.
            return;
        }
        await this.pageAccess();
    }

    handlerStartDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var filter_start_date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        this.setState({
            filter_start_date: filter_start_date
        }, () => { this.onLoadShowData() });
    }

    handlerEndDateTime = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var filter_end_date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        this.setState({
            filter_end_date: filter_end_date
        });
    }

    handlerStartDateTimeForNewTransporter = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var valid_from = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        this.setState({
            valid_from: valid_from
        });
    }

    handlerEndDateTimeForNewTransporter = (event, currentDate, selectedDate) => {
        var d = new Date(event._d);

        var valid_to = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        this.setState({
            valid_to: valid_to
        });
    }

    filterDataByMonth = async () => {
        await this.setState({
            filter_start_date: this.state.filter_start_date
        });
        await this.onLoadShowData();
    }
    async onClickTab(data_type, type) {
        var regularActive = "";
        var truckActive = "";
        var courierActive = "";
        var hubActive = "";
        var airCourierActive = "";
        if (data_type == 1 && type != "hub") {
            regularActive = "activet";
        }
        else if (data_type == 2 && type != "airCourier") {
            truckActive = "activet";
        } else if (data_type == 3) {
            courierActive = "activet";
        } else if (data_type == 1 && type == "hub") {
            hubActive = "activet";
        } else if (data_type == 2 && type == "airCourier") {
            airCourierActive = "activet";
        }
        await this.setState({
            data_type: data_type,
            regularActive: regularActive,
            truckActive: truckActive,
            courierActive: courierActive,
            hubActive: hubActive,
            airCourierActive: airCourierActive
        });
        if (type == "hub") {
            return;
        }
        await this.onLoadShowData();
    }
    getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        this.setState({ fileName: file.name }); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            this.validateExcelData(data);
        };
    };


    validateExcelData = (data) => {

        let validationErrors = [];
        let overPercentErrors = [];
        let cleanedData = [];

        let zoneMap = {};

        data.forEach((row, index) => {

            const rowNumber = index + 2;

            let zone = String(row["Zone"] || "");
            let transporterCode = row["Transporter Code"];
            let approvedSOB = row["Approved SOB"];

            let rowErrors = [];

            // ---- Transporter (by CODE only - the name comes from the master) ----
            const masterTransporter = findTransporterByCode(this.state.trnsportersList, transporterCode);
            if (!masterTransporter) {
                rowErrors.push(
                    `Transporter Code - "${transporterCode}" is not in transporter master for this warehouse`
                );
            }

            // ---- Hub ----
            if (!this.checkZoneIdentity(zone)) {
                rowErrors.push(`Zone - "${zone}" does not exist in available zones`);
            }

            // ---- Approved SOB ----
            if (!this.isValidNumber(approvedSOB) || parseFloat(approvedSOB) < 0) {
                rowErrors.push(
                    `Approved SOB should be numeric and >= 0 (${approvedSOB})`
                );
            }

            // ---- Collect Errors or Valid Data ----
            if (rowErrors.length > 0) {
                validationErrors.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {

                const parsedSOB = parseFloat(approvedSOB);

                const cleanedRow = {
                    rowNumber,
                    transporter_name: masterTransporter.transporter_name,
                    transporter_code: masterTransporter.transporter_code,
                    zone: zone,
                    sob: parsedSOB,
                    valid_from: this.state.valid_from,
                    valid_to: this.state.valid_to
                };

                cleanedData.push(cleanedRow);

                if (!zoneMap[zone]) {
                    zoneMap[zone] = {
                        total: 0,
                        rows: []
                    };
                }

                zoneMap[zone].total += parsedSOB;
                zoneMap[zone].rows.push(cleanedRow);
            }
        });

        // ---- REMOVE INVALID ROWS SET ----
        const invalidRowNumbers = new Set(
            validationErrors.map((e) => e.row)
        );

        // ---- HUB LEVEL VALIDATION (ONE ERROR PER HUB) ----
        Object.keys(zoneMap).forEach((hub) => {

            if (zoneMap[hub].total > 100) {

                overPercentErrors.push({
                    hub: hub,
                    error: `Total Approved SOB for Hub "${hub}" exceeds 100 (Current Total: ${zoneMap[hub].total})`
                });

                // mark rows invalid
                zoneMap[hub].rows.forEach((row) => {
                    invalidRowNumbers.add(row.rowNumber);
                });
            }
        });

        // ---- FILTER VALID ROWS ----
        cleanedData = cleanedData.filter(
            (row) => !invalidRowNumbers.has(row.rowNumber)
        );

        // ---- FINAL DATA ----
        const finalData = cleanedData.map(({ rowNumber, ...rest }) => rest);

        // setErrors(validationErrors);
        // setOverErrors(overPercentErrors);
        // setValidData(finalData);
        if (finalData.length == 0 && validationErrors.length == 0 && overPercentErrors.length == 0) {
            validationErrors.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }
        this.setState({
            errors: validationErrors,
            overErrors: overPercentErrors,
            validData: finalData
        })

        console.log("Validation Errors:", validationErrors);
        console.log("Over Percent Errors:", overPercentErrors);
        console.log("Valid Data:", finalData);
    };

    checkZoneIdentity = (name) => {
        const uniqueZones = [...new Set(this.state.statesList)];
        return uniqueZones.includes(name);
    };











    isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^\d+(\.\d+)?$/.test(str);
    };
    updateHubSOBData = async (data, type) => {
        try {
            var params = {
                loading_port_code: this.state.loading_port_code,
                data_type: this.state.data_type, is_hub: 0, type,
                data: data, is_air_courier: this.state.airCourierActive == "activet" ? 1 : 0
            }
            console.log(params)
            const response = await redirectURL.post("/lmconsignees/saveBulkLmHubSOBData", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    handleBulkUpload = async () => {

        try {
            this.setState({
                overly: 'show-m',
                load: 'show-m',
            })

            const finalData = this.state.validData
            console.log(finalData)

            await this.updateHubSOBData(finalData, "insert")
            await this.onLoadShowData();
            this.setState({
                overly: 'show-n',
                load: 'show-n',
                validData: [],
                errors: [],
                overErrors: [],
                showBulkSlider: false,
                valid_from: "",
                valid_to: "", fileName: ""
            })

            if (this.fileInputRef.current) {
                this.fileInputRef.current.value = "";
            }

        } catch (err) {
            console.error(err);
        }
    };
    onClickSOBUpdate = async () => {
        const hub = this.state.editHubSOB.hub;
        const originalValues = this.state.editHubSOB.originalValues || [];
        const hasChanges = this.state.editHubSOB.data.some((each) => {
            var original = originalValues.find((o) => o.transporter_code == each.transporter_code);
            var originalValue = original ? original.value : 0;
            var currentValue = parseFloat(each[hub]) || 0;
            return originalValue !== currentValue;
        });
        if (!hasChanges) {
            this.setState({
                basicTitle: "No Changes Made.",
                basicType: "warning",
                show: true,
                editHubSOB: { open: false, hub: "", data: [], total: 0 }
            })
            return;
        }
        const correctedData = this.state.editHubSOB.data.map((each) => {
            return ({
                transporter_code: each.transporter_code,
                transporter_name: each.transporter_name,
                is_hub: 0, is_air_courier: this.state.airCourierActive == "activet" ? 1 : 0,
                data_type: this.state.data_type,
                vaild_from: this.state.data_valid_from,
                valid_to: this.state.data_valid_to,
                zone: hub,
                sob: parseFloat(each[hub] || 0),
                loading_port_code: this.state.loading_port_code,
            })
        })
        console.log(correctedData)
        this.setState({
            overly: "show-m",
            load: "show-m"
        })
        await this.updateHubSOBData(correctedData, "update");
        await this.onLoadShowData();
        this.setState({
            overly: "show-n",
            load: "show-n",
            editHubSOB: { open: false, hub: "", data: [], total: 0 }
        })
    }

    render() {

        var columnwithDefs = [
            {
                headerName: "Transporter",
                field: "transporter_name",
                width: 150,
                
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.trnsportersList,
                // },
            },

            {
                headerName: "State",
                field: "state",
                width: 290,
                
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.statesList,
                // },
            },
            {
                headerName: "Share Of Business",
                field: "sob",
                width: 100,
                
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
            },
            {
                pinned: "left",
                headerName: "id",
                field: "id",
                width: 100,
                
            },
        ]
        var assignCheck = (!this.state.data_valid_from && !this.state.data_valid_to)
        this.assignCheckRef.current = assignCheck;
        var disableUpdate = this.state.editHubSOB.total > 100;
        var errTrueUpload = this.state.errors.length > 0 && this.state.validData.length > 0
        var disableUpload = (this.state.validData.length == 0 || !this.state.valid_from || !this.state.valid_to || this.state.overErrors.length > 0)
        var disableUploadBtn = !this.state.valid_from || !this.state.valid_to;
        var userroles = localStorage.getItem("roles")
        return (
            <div className="container-fluid d-flex flex-column" style={{ height: "100%" }}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                    <div className="row" style={{ marginBottom: "10px", flexShrink: 0 }}>
                        <div className="col-sm-12">
                            <ul
                                style={{
                                    display: "inline-flex",
                                    flexWrap: "wrap",
                                    padding: "4px",
                                    margin: 0,
                                    listStyle: "none",
                                    gap: "4px",
                                    backgroundColor: "#ffffff",
                                    borderRadius: "10px",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                                }}
                            >
                                {[
                                    { onClick: this.onClickTab.bind(this, 1, "hub"), label: "Hub", active: this.state.hubActive },
                                    { onClick: this.onClickTab.bind(this, 1, ""), label: "Regular", active: this.state.regularActive },
                                    ...((userroles.indexOf("lm_FullAccess") >= 0) ? [{ onClick: this.onClickTab.bind(this, 2, ""), label: "Surface Courier", active: this.state.truckActive }] : []),
                                    { onClick: this.onClickTab.bind(this, 2, "airCourier"), label: "Air Courier", active: this.state.airCourierActive },
                                    { onClick: this.onClickTab.bind(this, 3, ""), label: "Dedicated", active: this.state.courierActive },
                                ].map(({ onClick, label, active }, idx) => {
                                    var isActive = active == "activet";
                                    return (
                                        <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                                            <button
                                                type="button"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    border: "none",
                                                    outline: "none",
                                                    borderRadius: "999px",
                                                    padding: "8px 18px",
                                                    fontSize: "13px",
                                                    fontWeight: isActive ? 600 : 500,
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease",
                                                    backgroundColor: isActive ? "#1976d2" : "transparent",
                                                    color: isActive ? "#fff" : "#555",
                                                    boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                                }}
                                            >
                                                {label}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    

                {this.state.hubActive == "activet" ?
                    // <div className="bg-primary" style={{ flexGrow: 1 }}>
                    <HubSOBPage />
                    // </div>
                    :
                    <>
                        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", flex: "1 1 0%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", flexShrink: 0 }}>
                                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Approved SOB Percentage</h5>
                                </div>
                                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                                    {(this.state.data_valid_from != "" && this.state.data_valid_from != undefined) ?
                                        <div className="d-flex align-items-center" style={{ backgroundColor: "#f4f6f8", borderRadius: "999px", padding: "7px 14px", gap: "6px" }}>
                                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>Data Valid :</span>
                                            <span style={{ fontSize: "12px", fontWeight: 700, color: "#2e7d32", whiteSpace: "nowrap" }}>{getHyphenDDMMMYYYY(this.state.data_valid_from)}</span>
                                            <span style={{ fontSize: "12px", color: "#90a4ae" }}>→</span>
                                            <span style={{ fontSize: "12px", fontWeight: 700, color: "#c62828", whiteSpace: "nowrap" }}>{getHyphenDDMMMYYYY(this.state.data_valid_to)}</span>
                                        </div>
                                        : ""}
                                    <div className="d-flex align-items-center" style={{ backgroundColor: "#efefef", borderRadius: "999px", padding: "4px 6px 4px 14px", gap: "6px" }}>
                                        <span style={{ fontSize: "13px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>Filter By Date :</span>
                                        <div style={{ width: "105px" }}>
                                            <Datetime
                                                value={this.state.filter_start_date}
                                                disableCloseOnClickOutside={false}
                                                closeOnSelect={true}
                                                inputProps={{
                                                    placeholder: 'Select Date',
                                                    name: 'from_date',
                                                    autoComplete: 'off',
                                                    style: { border: "none", outline: "none", backgroundColor: "transparent", fontSize: "13px", fontWeight: 600, color: "#263238", cursor: "pointer", width: "100%", padding: "4px 0" }
                                                }}
                                                dateFormat="YYYY-MM-DD"
                                                name="filter_start_date"
                                                onChange={this.handlerStartDateTime.bind(this)}
                                            />
                                        </div>
                                        <i className="icofont icofont-ui-calendar" style={{ color: "#1976d2", fontSize: "14px", paddingRight: "8px", pointerEvents: "none" }}></i>
                                    </div>
                                    {(this.state.pageAccess != 2) ?
                                        <button type="button" onClick={this.updateGridData.bind(this)} className="pill-btn d-none" style={{ backgroundColor: "#f57c00", color: "#fff" }}>Assign</button>
                                        : ""}
                                    {(this.state.pageAccess != 2) ?
                                        <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                                        : ""}
                                </div>
                            </div>

                            <div className="card-body col-xl-12 col-lg-12 d-none">
                                <div id="myGrid" style={{ width: "100%", height: "500px" }} className={"ag-theme-balham " + this.state.showGridData}>
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={columnwithDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.rowData}
                                        enableCharts={false}
                                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        frameworkComponents={this.state.frameworkComponents}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        stopEditingWhenGridLosesFocus={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={false}
                                        gridOptions={{
                                            context: { componentParent: this },
                                            getRowStyle: function (params) {
                                                if (params.node.rowPinned) {
                                                    return { 'font-weight': 'bold', 'font-size': '16px' };
                                                }
                                            },
                                        }}
                                        // components={this.state.components}
                                        enableRangeSelection={true}
                                        rowHeight={45}
                                        headerHeight={45}
                                        onCellClicked={this.onCellClicked.bind(this)}
                                        onCellEditingStopped={this.onCellUpdateData.bind(this)} pinnedBottomRowData={this.state.pinnedRegionBottomRowData}

                                    />
                                </div>
                            </div>
                            {/* GRID */}
                            <div className="ag-theme-balham grid-wrapper mx-3 mt-3 mb-3" style={{ flex: 1, minHeight: 0 }}>
                                <AgGridReact
                                    // ref={gridRef}
                                    modules={this.state.modules}
                                    rowData={this.state.rowData}
                                    columnDefs={this.state.columnwithDefs}
                                    defaultColDef={{
                                        sortable: true,
                                        filter: true, resizable: true,
                                        floatingFilter: true
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                            { statusPanel: "agFilteredRowCountComponent", align: "right" },
                                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                                        ]
                                    }}
                                    animateRows
                                    rowHeight={45}
                                    headerHeight={45}
                                    frameworkComponents={this.state.frameworkComponents}
                                    onSelectionChanged={() => {
                                        // if (gridRef && gridRef.current && gridRef.current.api) {
                                        //     const selected = gridRef.current.api.getSelectedRows();
                                        //     setSelectedRows(selected);
                                        // }
                                    }} onCellClicked={this.onCellClicked.bind(this)}
                                    pinnedBottomRowData={this.state.pinnedRegionBottomRowData || []}
                                />
                            </div>
                        </div>

                        <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

                            <div className="slider-header">
                                {`${(this.state.zoneStates[0] || {}).state} States`}
                                <span onClick={this.onClickHideAll.bind(this)}>✕</span>
                            </div>

                            <div className="slider-body flex-grow-1 pt-4">
                                {this.state.zoneStates.slice(1,).map((each) => {
                                    return <p className="font-bold" style={{ color: "#000", fontWeight: "bold" }}>{each.state}</p>
                                })}

                            </div>

                        </div>


                        <div className={`hub-slider ${this.state.showBulkSlider ? "open" : ""} d-flex flex-column`}>

                            <div className="slider-header">
                                Bulk Upload Hub
                                <span onClick={this.onClickHideAll.bind(this)}>✕</span>
                            </div>

                            <div className="slider-body flex-grow-1">
                                <div className="" style={{ width: "100%" }}>
                                    <p className="mb-1">Valid From</p>
                                    <div className="flex-grow-1">
                                        <Datetime
                                            value={this.state.valid_from || ""}
                                            disableCloseOnClickOutside={false}
                                            closeOnSelect={true}
                                            inputProps={{
                                                placeholder: 'Select Date',
                                                name: 'valid_from',
                                                autoComplete: 'off'
                                            }}
                                            dateFormat="YYYY-MM-DD"
                                            name="valid_from"
                                            onChange={this.handlerStartDateTimeForNewTransporter.bind(this)}
                                        />
                                    </div>
                                </div>
                                <div className="mt-2" style={{ width: "100%" }}>
                                    <p className="mb-1">Valid To</p>
                                    <div className="flex-grow-1">
                                        <Datetime
                                            value={this.state.valid_to || ""}
                                            disableCloseOnClickOutside={false}
                                            closeOnSelect={true}
                                            inputProps={{
                                                placeholder: 'Select Date',
                                                name: 'valid_to',
                                                autoComplete: 'off'
                                            }}
                                            dateFormat="YYYY-MM-DD"
                                            name="valid_to"
                                            onChange={this.handlerEndDateTimeForNewTransporter.bind(this)}
                                        />
                                    </div>
                                </div>
                                <input
                                    ref={this.fileInputRef}
                                    type="file"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={this.handleFileChange}
                                    style={{ display: "none" }}
                                />
                                {/* Upload button */}
                                <div className="d-flex align-items-center gap-3 mt-3">
                                    <button
                                        className="btn btn-info d-flex justify-content-center p-3"
                                        type="button"
                                        onClick={() => this.fileInputRef.current.click()}
                                        disabled={disableUploadBtn}
                                        style={{ cursor: disableUploadBtn && "not-allowed", opacity: disableUploadBtn && "0.5" }}
                                        title={disableUploadBtn ? "Please select date range before uploading the file" : ""}
                                    >
                                        Upload File
                                    </button>

                                    <a href={require("../../assets/json/sample_lmapprovedsob.csv")} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                                        Download Sample Template
                                    </a>
                                </div>

                                {this.state.fileName && (
                                    <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                                        <span>Selected File :</span>
                                        <span
                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                flex: 1,
                                                fontWeight: "bold"
                                            }}
                                            title={this.state.fileName}
                                        >
                                            {this.getShortFileName(this.state.fileName)}
                                        </span>
                                    </div>
                                )}

                                {this.state.overErrors.length > 0 && <div>
                                    <p className="text-danger" style={{ fontSize: "15px", fontWeight: "bold", color: "#000" }}>Hub Over Percentage Errors</p>
                                    {this.state.overErrors.map((err, i) => (
                                        <div key={i} style={{ color: "#000" }}>
                                            <b>{err.hub}:</b> {err.error}
                                        </div>
                                    ))}
                                </div>}

                                {this.state.errors.length > 0 && (
                                    <>
                                        <h6 className="text-danger mt-3">Validation Errors</h6>

                                        <div className="" style={{ width: "100%" }}>
                                            <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative", height: "100%" }}>
                                                <thead className="table-light text-center"
                                                // style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}
                                                >
                                                    <tr>
                                                        <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                                        <th>Error Description</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {this.state.errors.map((err, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center" style={{ padding: "9px 15px" }}>
                                                                {err.row}
                                                            </td>

                                                            <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                                {err.errors.map((e, idx) => (
                                                                    <p className="m-0" key={idx}>{e}</p>
                                                                ))}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}

                            </div>
                            <div className="slider-footer">
                                <button
                                    className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                                    onClick={this.handleBulkUpload}
                                    disabled={disableUpload}
                                >
                                    {errTrueUpload ? "Upload only valid data" : "Upload"}
                                </button>
                            </div>

                        </div>

                        <div className={`hub-slider ${this.state.editHubSOB.open ? "open" : ""} d-flex flex-column`} style={{ width: "590px", right: !this.state.editHubSOB.open && "-590px" }}>

                            <div className="slider-header">
                                {`${this.state.editHubSOB.hub}`}
                                <span onClick={this.onClickHideAll.bind(this)}>✕</span>
                            </div>

                            <div
                                className="flex-grow-1"
                                style={{ overflowY: "auto" }}
                            >
                                {this.state.editHubSOB.total > 100 && (
                                    <p className="m-0 px-3 pt-3" style={{ color: "red", marginTop: "8px", backgroundColor: "#fff", position: "sticky", top: 0, zIndex: 1, left: 0 }}>
                                        ⚠️ Total SOB must not be greater than 100%
                                    </p>
                                )}
                                <div style={{ width: "100%", height: "100%" }} className="p-3 d-flex flex-column">
                                    <table className="htu"
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        <thead>
                                            <tr className="">
                                                <th style={{}}>
                                                    Transporter Name
                                                </th>
                                                <th style={{}}>
                                                    Transporter Code
                                                </th>
                                                <th style={{}}>
                                                    {this.state.editHubSOB.hub}
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody style={{ height: "250px", overflowY: "auto" }}>
                                            {(this.state.editHubSOB.data || []).map((row, index) => (
                                                <tr key={index}>
                                                    <td>{row.transporter_name}</td>
                                                    <td>{row.transporter_code}</td>
                                                    <td className="d-flex justify-content-center">
                                                        <input
                                                            type="text"
                                                            className="form-default"
                                                            value={row[this.state.editHubSOB.hub] || ""}
                                                            style={{ width: "100px", color: "blue" }}
                                                            onChange={(e) => {
                                                                let value = e.target.value;

                                                                // ✅ Allow empty OR positive float
                                                                if (value === "" || /^\d*\.?\d*$/.test(value)) {

                                                                    // ❌ prevent multiple dots like 1.2.3
                                                                    if ((value.match(/\./g) || []).length > 1) return;

                                                                    let updated = [...this.state.editHubSOB.data];
                                                                    updated[index][this.state.editHubSOB.hub] = value;

                                                                    // ✅ calculate total
                                                                    let total = updated.reduce(
                                                                        (sum, row) => sum + (parseFloat(row[this.state.editHubSOB.hub]) || 0),
                                                                        0
                                                                    );

                                                                    // setEditHubSOB(prev => ({
                                                                    //     ...prev,
                                                                    //     data: updated,
                                                                    //     total
                                                                    // }));
                                                                    this.setState((prevState) => ({
                                                                        editHubSOB: {
                                                                            ...prevState.editHubSOB, data: updated,
                                                                            total
                                                                        }
                                                                    }))
                                                                }
                                                            }}
                                                            placeholder="0"
                                                            // 🔥 Block invalid key presses
                                                            onKeyDown={(e) => {
                                                                if (["-", "e", "E", "+"].includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}

                                                            // 🔥 Prevent invalid paste
                                                            onPaste={(e) => {
                                                                const paste = e.clipboardData.getData("text");
                                                                if (!/^\d*\.?\d*$/.test(paste)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                        <tfoot>
                                            <tr style={{

                                                zIndex: 2
                                            }}>
                                                <td colSpan="2" className="text-center py-2"><b>Total</b></td>
                                                <td
                                                    style={{

                                                        zIndex: 2
                                                    }} className="text-center py-2"
                                                >
                                                    <b style={{ color: this.state.editHubSOB.total > 100 ? "red" : "green" }}>{this.state.editHubSOB.total} %</b>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <div className="slider-footer">
                                <button
                                    className="save-btn" style={{ margin: "0px", cursor: disableUpdate && "not-allowed", opacity: disableUpdate && "0.5" }}
                                    onClick={this.onClickSOBUpdate}
                                    disabled={disableUpdate}
                                >
                                    {"Update"}
                                </button>
                            </div>
                        </div>

                        {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                        <div className={"slide-r d-none" + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                            <h3 className="subH">Bulk Upload</h3>
                            <div className="slide-r-body" style={{ position: "relative" }}>

                                <div className="container-fluid">
                                    {(this.state.sliderType == 2) ?
                                        <div className="row">
                                            <table className="table">
                                                <tbody>
                                                    {this.state.zoneStates.map(function (zs) {
                                                        return <tr>
                                                            <td style={{ padding: "5px", border: "none" }}>{zs.state}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <div className="row">
                                            <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>
                                                <div className="form-group mt-20p">
                                                    <label className="">Valid From</label>
                                                    <Datetime
                                                        value={this.state.valid_from}
                                                        disableCloseOnClickOutside={false}
                                                        closeOnSelect={true}
                                                        inputProps={{
                                                            placeholder: 'Select Date',
                                                            name: 'valid_from',
                                                            autoComplete: 'off'
                                                        }}
                                                        dateFormat="YYYY-MM-DD"
                                                        name="valid_from"
                                                        onChange={this.handlerStartDateTimeForNewTransporter.bind(this)}
                                                    />
                                                </div>
                                                <div className="form-group mt-20p">
                                                    <label className="">Valid To</label>
                                                    <Datetime
                                                        value={this.state.valid_to}
                                                        disableCloseOnClickOutside={false}
                                                        closeOnSelect={true}
                                                        inputProps={{
                                                            placeholder: 'Select Date',
                                                            name: 'valid_to',
                                                            autoComplete: 'off'
                                                        }}
                                                        dateFormat="YYYY-MM-DD"
                                                        name="valid_to"
                                                        onChange={this.handlerEndDateTimeForNewTransporter.bind(this)}
                                                    />
                                                </div>

                                                <div className="form-group mt-20p">
                                                    <label className="">Upload File</label>
                                                    <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="form-control" required />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-success">Submit</button>
                                                    <button type="button" onClick={this.resetUpload.bind(this)} className="btn btn-default">Cancel</button>
                                                </div>
                                            </form>
                                            <div className="form-group">
                                                <a className="btn btn-primary" href={require('../../assets/json/sample_lmapprovedsob.csv')} target="_blank">Sample Template</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                        <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
                    </>}
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}


function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};
function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}


const HubSOBPage = () => {
    // const location = useLocation();
    const gridRef = useRef();
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);

    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    // ---------------- SLIDER STATE ----------------
    const [showSlider, setShowSlider] = useState(false);
    const [editHubSOB, setEditHubSOB] = useState({ open: false });
    // ---------------- DROPDOWN ----------------
    const loadingPorts = [
        { value: "CHN", label: "Chennai" },
        { value: "MUM", label: "Mumbai" },
        { value: "KOL", label: "Kolkata" }
    ];

    // ---------------- FORM ----------------
    const [formData, setFormData] = useState({
        loading_port_code: null,
        hub_name: "",
        latitude: "",
        longitude: ""
    });

    const [rowData, setRowData] = useState(
    );
    const [editIndex, setEditIndex] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    console.log(loadingPortData, editIndex)

    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(0);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [transporterData, setTransporterData] = useState([]);
    const [hubCityData, setHubCityData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [timeData, setTimeData] = useState({ from_date: moment.parseZone().format("YYYY-MM-DD") });
    const [controller, setController] = useState({ open: false });
    const [hubSOBData, setHubSOBData] = useState([]);
    const [calculatedData, setCalculatedData] = useState([]);

    const [totalRowData, setTotalRowData] = useState([]);
    const [cityList, setCityList] = useState([])
    const fileInputRef = useRef(null);

    const [overErrors, setOverErrors] = useState([])

    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setFormData({
            loading_port_code: null,
            hub_name: "",
            latitude: "",
            longitude: ""
        });
        setValidData([])
        setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
        setFileName("")
        setErrors([])
        setOverErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        setController((prevState) => ({...prevState, open: false}))
        setEditHubSOB((prevState) => ({...prevState, open: false}))
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };


    // const ActionRenderer = (props) => (
    //     <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

    //         <Edit className="text-primary cursor-pointer ml-2"
    //             size={15} style={{ cursor: "pointer" }} onClick={() => { handleEdit(props) }} />
    //         <Trash className="text-danger cursor-pointer ml-2"
    //             size={15} style={{ cursor: "pointer" }} onClick={() => { handleDelete(props) }} />
    //     </div>
    // );
    // ---------------- GRID ----------------
    const components = {
        // actionRenderer: ActionRenderer
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            var code = await pageAccessFn();
            // await getLoadingPortCodeData();
            var transporter = await getTransportersData(code);
            var hubCity = await getHubCityData(code);
            var sobData = await getHubSOBData(code);
            createColumnDefs(transporter, hubCity);
            createRows(transporter, hubCity, sobData);
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);
    
    const pageAccessFn = async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;

        try {
            const resolved = await resolvePageAccess(currentUrl, portContext);
            if (!resolved) {
                // No access (already alerted+redirected), empty port list, or a logged request error.
                return;
            }
            lastPortRef.current = resolved.loading_port_code;
            setPageAccess(resolved.pageAccess);
            setLoadingPortCode(resolved.loading_port_code);
            setCompCode(resolved.comp_code);
            setLoadingPortData(resolved.lpNames);
            return resolved.loading_port_code;
        } catch (err) {
            console.log(err);
        }

    };

    // React to the loading port changing from the header's global selector.
    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection.
            return;
        }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await onClickSubmit(selectedPlant, timeData.from_date);
        setValidData([]);
        setErrors([]);
        setOverErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };

    const getHubSOBData = async (port, date) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                data_type: 1,
                filter_start_date: date ? date : timeData.from_date, is_hub: 1
            }
            const response = await redirectURL.post("/lmconsignees/getLmHubShareOfBusiness", params);
            if (response.data.status == "success") {
                setHubSOBData(response.data.sobData || [])
                var from_date_ac = "";
                var to_date_ac = "";
                if (response.data.sobData.length > 0) {
                    from_date_ac = response.data.sobData[0].valid_from;
                    to_date_ac = response.data.sobData[0].valid_to;
                }
                setTimeData((prevState) => ({ ...prevState, from_date_ac, to_date_ac }))
                createRows(transporterData, hubCityData, response.data.sobData);
                return response.data.sobData
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getTransportersData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                data_type: 1, hub_transporter: 1,
                status: 1
            }
            const response = await redirectURL.post("/lmconsignees/prtUniqueTransportersListWithNames", params);
            if (response.status == "200") {
                setTransporterData(response.data.filter((each) => each.transporter_code) || [])
                return response.data.filter((each) => each.transporter_code)
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getHubCityData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                is_active: 1
            }
            const response = await redirectURL.post("/masters/getHubConsigneeCity", params);
            if (response.data.status == "success") {
                setHubCityData(response.data.hubMappingData || [])
                return response.data.hubMappingData || []
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLoadingPortCodeData = async () => {
        try {
            var params = {

            }
            const response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setLoadingPortData(
                    response.data
                        ? response.data.map((each) => ({
                            ...each,
                            label: each.comp_short_name,
                            value: each.loading_port_code
                        }))
                        : []
                );
                setLoadingPortCode(response.data[0].loading_port_code || "")
                return response.data[0].loading_port_code
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const createColumnDefs = (tArray, hArray) => {
        const uniqueHubs = [...new Set(hArray.map(e => e.hub_name))];

        const columnDefs = [
            { headerName: "Transporter Name", field: "transporter_name", width: 250 },
            { headerName: "Transporter Code", field: "transporter_code", width: 190 },

            ...uniqueHubs.map((hub) => ({
                headerName: hub,
                field: hub,
                width: 190,
                cellRendererFramework: (params) => {
                    if (Array.isArray(params.value) && params.value.length > 0) {
                        return (
                            <>
                                <span
                                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => handleViewCities(hArray, params.colDef.headerName)}
                                >
                                    {params.value[0]}
                                </span>
                                <span className="ml-3"
                                    style={{ color: "green", cursor: "pointer", textDecoration: "underline", cursor: assignCheckRef.current && "not-allowed", opacity: assignCheckRef.current && "0.5" }}
                                    onClick={() => { !assignCheckRef.current && handleEditHubSOB(params.colDef.headerName) }}
                                    disabled={assignCheckRef.current}
                                >
                                    {params.value[1]}
                                </span>
                            </>
                        );
                    }
                    return params.value;
                }

            }))
        ];
        setColumnDefs(columnDefs);
    };
    var totalDataRef = useRef([]);
    const createRows = (transporters, hubCity, transdata) => {
        let rowdefs = [];
        const uniqueHubs = [...new Set(hubCity.map(e => e.hub_name))];
        transporters.forEach((ste) => {
            let rows = {
                transporter_name: ste.transporter_name,
                transporter_code: ste.transporter_code
            };

            // initialize all hubs with 0
            uniqueHubs.forEach((hub) => {
                rows[hub] = 0;
            });

            // fill actual data
            transdata.forEach((t) => {
                if (t.transporter_code === ste.transporter_code) {
                    rows[t.zone] = parseFloat(t.sob) || 0;
                }
            });

            rowdefs.push(rows);
        });

        // 🔹 Total Row
        let totalRow = {
            transporter_name: "Total",
            transporter_code: "Total"
        };

        uniqueHubs.forEach((hub) => {
            totalRow[hub] = 0;
        });

        rowdefs.forEach((row) => {
            uniqueHubs.forEach((hub) => {
                totalRow[hub] += parseFloat(row[hub]) || 0;
            });
        });

        // 🔹 View Row
        let hubDetails = {
            transporter_name: "",
            transporter_code: ""
        };

        uniqueHubs.forEach((hub) => {
            hubDetails[hub] = ["View Cities", "Edit"];
        });
        setCalculatedData([...rowdefs])
        setTotalRowData([hubDetails, totalRow])
        totalDataRef.current = [...rowdefs];
        // return {
        //     rowData: [...rowdefs, hubDetails],
        //     totalRow
        // };
    };
    const handleViewCities = (hArray, hub) => {
        setCityList([hub, ... new Set(hArray.filter((each) => each.hub_name == hub).map((each) => each.consignee_city))]);
        setShowSlider(true);
    }
    const handleEditHubSOB = (hub) => {
        console.log(totalDataRef.current, hub)
        setEditHubSOB({
            open: true,
            hub: hub,
            data: totalDataRef.current,
            total: totalDataRef.current.reduce((sum, row) => sum + (Number(row[hub]) || 0), 0)
        })
    }
    const updateHubSOBData = async (data, type) => {
        try {
            var params = {
                loading_port_code: loadingPortCode,
                data_type: 1, is_hub: 1, type,
                data: data
            }
            console.log(params)
            const response = await redirectURL.post("/lmconsignees/saveBulkLmHubSOBData", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            const finalData = validData
            // .map((each) => {
            //     return (
            //         {
            //             ...each,
            //             loading_port_code: loadingPortCode,
            //             comp_short_name: loadingPortData.find((each) => each.value == loadingPortCode).label || "",
            //             is_active: 1
            //         }
            //     )
            // })
            console.log(validData, finalData)

            await updateHubSOBData(finalData, "insert")
            await getHubSOBData();
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
            setFileName("")
            setErrors([])
            setOverErrors([])
            setShowBulkSlider(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };

    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")

    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        valueContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        container: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer",
            width: "100%"
        })
    }

    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };


    const validateExcelData = (data) => {

        let validationErrors = [];
        let overPercentErrors = [];
        let cleanedData = [];

        let hubMap = {};

        data.forEach((row, index) => {

            const rowNumber = index + 2;

            let hubName = String(row["Hub"] || "").trim().toUpperCase();
            let transporterCode = row["Transporter Code"];
            let approvedSOB = row["Approved SOB"];

            let rowErrors = [];

            // ---- Transporter (by CODE only - the name comes from the master) ----
            const masterTransporter = findTransporterByCode(transporterData, transporterCode);
            if (!masterTransporter) {
                rowErrors.push(
                    `Transporter Code - "${transporterCode}" is not in transporter master for this warehouse`
                );
            }

            // ---- Hub ----
            if (!checkHubIdentity(hubName)) {
                rowErrors.push(`Hub - "${hubName}" does not exist in Hub Master`);
            }

            // ---- Approved SOB ----
            if (!isValidNumber(approvedSOB) || parseFloat(approvedSOB) < 0) {
                rowErrors.push(
                    `Approved SOB should be numeric and >= 0 (${approvedSOB})`
                );
            }

            // ---- Collect Errors or Valid Data ----
            if (rowErrors.length > 0) {
                validationErrors.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {

                const parsedSOB = parseFloat(approvedSOB);

                const cleanedRow = {
                    rowNumber,
                    transporter_name: masterTransporter.transporter_name,
                    transporter_code: masterTransporter.transporter_code,
                    zone: hubName,
                    sob: parsedSOB,
                    valid_from: timeData.valid_from,
                    valid_to: timeData.valid_to
                };

                cleanedData.push(cleanedRow);

                if (!hubMap[hubName]) {
                    hubMap[hubName] = {
                        total: 0,
                        rows: []
                    };
                }

                hubMap[hubName].total += parsedSOB;
                hubMap[hubName].rows.push(cleanedRow);
            }
        });

        // ---- REMOVE INVALID ROWS SET ----
        const invalidRowNumbers = new Set(
            validationErrors.map((e) => e.row)
        );

        // ---- HUB LEVEL VALIDATION (ONE ERROR PER HUB) ----
        Object.keys(hubMap).forEach((hub) => {

            if (hubMap[hub].total > 100) {

                overPercentErrors.push({
                    hub: hub,
                    error: `Total Approved SOB for Hub "${hub}" exceeds 100 (Current Total: ${hubMap[hub].total})`
                });

                // mark rows invalid
                hubMap[hub].rows.forEach((row) => {
                    invalidRowNumbers.add(row.rowNumber);
                });
            }
        });

        // ---- FILTER VALID ROWS ----
        cleanedData = cleanedData.filter(
            (row) => !invalidRowNumbers.has(row.rowNumber)
        );

        // ---- FINAL DATA ----
        const finalData = cleanedData.map(({ rowNumber, ...rest }) => rest);
        if (finalData.length == 0 && validationErrors.length == 0 && overPercentErrors.length == 0) {
            validationErrors.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }



        setErrors(validationErrors);
        setOverErrors(overPercentErrors);
        setValidData(finalData);

        console.log("Validation Errors:", validationErrors);
        console.log("Over Percent Errors:", overPercentErrors);
        console.log("Valid Data:", finalData);
    };
    const checkHubIdentity = (name) => {
        const uniqueHubs = [...new Set(hubCityData.map(e => e.hub_name))];
        return uniqueHubs.includes(name);
    };

    const isValidNumber = (value) => {
        const str = String(value).trim();
        return str !== "" && /^\d+(\.\d+)?$/.test(str);
    };

    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = (validData.length == 0 || !timeData.valid_from || !timeData.valid_to || overErrors.length > 0)
    var disableUpdate = editHubSOB.total > 100;
    var assignCheck = (!timeData.from_date_ac && !timeData.to_date_ac)
    var assignCheckRef = useRef(false);
    var disableUploadBtn = !timeData.valid_from || !timeData.valid_to

    assignCheckRef.current = assignCheck;
    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };

    const handlerTime = async (event, name, type) => {
        var d = new Date(event._d);

        var date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        // this.setState({
        //     valid_from: valid_from
        // });
        setTimeData((prevState) => ({
            ...prevState,
            [name]: date
        }))
        if (type) {
            await onClickSubmit(loadingPortCode, date);
        }
    }

    const addNewHubSOB = () => {
        // var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        // var stateArray = this.state.statesList.map((each) => ({ label: each, value: each }));
        // var vehicleCapacityArray = this.state.vehicleCap.map((each) => ({ label: each, value: each }));
        var transporterArray = transporterData.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        const uniqueHubs = [...new Set(hubCityData.map(e => e.hub_name))];
        var clubbingResourceArray = [
            {
                id: 1,
                title: "Valid From",
                field: "valid_from",
                type: "date",
                inputData: { placeholder: "Select Date", name: "valid_from", dateFormat: "YYYY-MM-DD" },
                errMsg: "Please select the Valid From",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "Valid To",
                field: "valid_to",
                type: "date",
                inputData: { placeholder: "Select Date", name: "valid_to", dateFormat: "YYYY-MM-DD" },
                errMsg: "Please select the Valid To",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Transporter",
                field: "transporter_code",
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            ...uniqueHubs.map((hub, index) => ({
                id: 4 + index,
                title: `${hub} SOB ( % )`,
                field: hub,
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            }))
        ];
        var titleLabel = "Add New Hub SOB"
        this.setState({
            controller: {
                open: true,
                title: titleLabel,
                btnType: "Add",
                formResourceArray: clubbingResourceArray,
                type: "add",
                formData: {}
            }
        })
    }
    const onClickSubmit = async (code, date) => {
        setLoadshow("show-m")
        setOverly("show-m")
        var transporter = await getTransportersData(code);
        var hubCity = await getHubCityData(code);
        var sobData = await getHubSOBData(code, date);
        createColumnDefs(transporter, hubCity);
        createRows(transporter, hubCity, sobData);
        setLoadshow("show-n")
        setOverly("show-n")
    }
    const onClickSOBUpdate = async () => {
        const correctedData = editHubSOB.data.map((each) => {
            return ({
                transporter_code: each.transporter_code,
                transporter_name: each.transporter_name,
                is_hub: 1,
                data_type: 1,
                vaild_from: timeData.from_date_ac,
                valid_to: timeData.to_date_ac,
                zone: editHubSOB.hub,
                sob: parseFloat(each[editHubSOB.hub] || 0),
                loading_port_code: loadingPortCode
            })
        })
        setLoadshow("show-m")
        setOverly("show-m")
        await updateHubSOBData(correctedData, "update");
        await getHubSOBData(loadingPortCode, timeData.from_date || "");
        setEditHubSOB({ open: false, hub: "", data: [] })
        setLoadshow("show-n")
        setOverly("show-n")
        // console.log(editHubSOB, timeData, correctedData)
    }



    return (
        <div className="hub-master-container d-flex flex-column card col-xl-12" style={{ flex: "1 1 0%", minHeight: 0, margin: "0px", padding: "10px 10px", overflowY: "auto" }}>

            {/* HEADER */}
            <div className="master-header px-3">
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Approved SOB Percentage</h5>
                </div>

                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                    {(timeData.from_date_ac != "" && timeData.from_date_ac != undefined) ?
                        <div className="d-flex align-items-center" style={{ backgroundColor: "#f4f6f8", borderRadius: "999px", padding: "7px 14px", gap: "6px" }}>
                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>Data Valid :</span>
                            <span style={{ fontSize: "12px", fontWeight: 700, color: "#2e7d32", whiteSpace: "nowrap" }}>{getHyphenDDMMMYYYY(timeData.from_date_ac)}</span>
                            <span style={{ fontSize: "12px", color: "#90a4ae" }}>→</span>
                            <span style={{ fontSize: "12px", fontWeight: 700, color: "#c62828", whiteSpace: "nowrap" }}>{getHyphenDDMMMYYYY(timeData.to_date_ac)}</span>
                        </div>
                        : ""}
                    <div className="d-flex align-items-center" style={{ backgroundColor: "#efefef", borderRadius: "999px", padding: "4px 6px 4px 14px", gap: "6px", fontSize: "13px", fontWeight: 400 }}>
                        <span style={{ fontSize: "13px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>Filter By Date :</span>
                        <div style={{ width: "105px" }}>
                            <Datetime
                                value={timeData.from_date || ""}
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                inputProps={{
                                    placeholder: 'Select Date',
                                    name: 'from_date',
                                    autoComplete: 'off',
                                    style: { border: "none", outline: "none", backgroundColor: "transparent", fontSize: "13px", fontWeight: 600, color: "#263238", cursor: "pointer", width: "100%", padding: "4px 0" }
                                }}
                                dateFormat="YYYY-MM-DD"
                                name="from_date"
                                onChange={async (e) => { await handlerTime(e, "from_date", true); }}
                            />
                        </div>
                        <i className="icofont icofont-ui-calendar" style={{ color: "#1976d2", fontSize: "14px", paddingRight: "8px", pointerEvents: "none" }}></i>
                    </div>
                    <button
                        className="pill-btn d-none"
                        onClick={() => {
                            // setShowSlider(true);
                            // var object = loadingPortData.find((each) => each.value == loadingPortCode)
                            // setFormData((prevState) => ({
                            //     ...prevState,
                            //     loading_port_code: object.value, comp_short_name: object.label
                            // }))
                        }} style={{ backgroundColor: "#f57c00", color: "#fff", cursor: assignCheck && "not-allowed", opacity: assignCheck && "0.5" }}
                        disabled={assignCheck}
                    >
                        Assign
                    </button>
                    <button
                        className="pill-btn pill-btn-info"
                        onClick={() => {
                            setErrors([]);
                            setValidData([]);
                            setFileName("");
                            setShowBulkSlider(true);
                        }}
                    >
                        Import Data
                    </button>
                </div>
            </div>

            {/* GRID */}
            <div className="ag-theme-balham grid-wrapper mx-3 mb-3" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={gridRef}
                    modules={modules}
                    rowData={calculatedData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true
                    }}
                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "right" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    animateRows
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                        }
                    }}
                    pinnedBottomRowData={totalRowData || []}
                />
            </div>

            {/* OVERLAY */}
            {showSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={() => {
                        setValidData([])
                        setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
                        setFileName("")
                        setErrors([])
                        setOverErrors([]);
                        setShowBulkSlider(false);
                        setBulkFile(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }}
                />
            )}
            {editHubSOB.open && (
                <div
                    className="slider-overlay"
                    onClick={() => {
                        setEditHubSOB({ open: false })
                    }}
                />
            )}

            {/* RIGHT SLIDER */}
            <div className={`hub-slider ${showSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    {`${cityList[0]} Hub Cities`}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 pt-4">
                    {cityList.slice(1,).map((each) => {
                        return <p className="font-bold" style={{ color: "#000", fontWeight: "bold" }}>{each}</p>
                    })}

                </div>
                <div className="slider-footer d-none">
                    <button
                        className="save-btn" style={{ margin: "0px" }}
                        onClick={""}
                    >
                        {editIndex !== null ? "Update" : "Save"}
                    </button>
                </div>
            </div>

            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Bulk Upload Hub
                    <span onClick={() => {
                        setValidData([])
                        setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
                        setFileName("")
                        setErrors([])
                        setOverErrors([]);
                        setShowBulkSlider(false);
                        setBulkFile(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }}>✕</span>
                </div>

                <div className="slider-body flex-grow-1">
                    <div className="" style={{ width: "100%" }}>
                        <p className="mb-1">Valid From</p>
                        <div className="flex-grow-1">
                            <Datetime
                                value={timeData.valid_from || ""}
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                inputProps={{
                                    placeholder: 'Select Date',
                                    name: 'valid_from',
                                    autoComplete: 'off'
                                }}
                                dateFormat="YYYY-MM-DD"
                                name="valid_from"
                                onChange={(e) => { handlerTime(e, "valid_from") }}
                            />
                        </div>
                    </div>
                    <div className="mt-2" style={{ width: "100%" }}>
                        <p className="mb-1">Valid To</p>
                        <div className="flex-grow-1">
                            <Datetime
                                value={timeData.valid_to || ""}
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                inputProps={{
                                    placeholder: 'Select Date',
                                    name: 'valid_to',
                                    autoComplete: 'off'
                                }}
                                dateFormat="YYYY-MM-DD"
                                name="valid_to"
                                onChange={(e) => { handlerTime(e, "valid_to") }}
                            />
                        </div>
                    </div>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3 mt-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                            disabled={disableUploadBtn}
                            style={{ cursor: disableUploadBtn && "not-allowed", opacity: disableUploadBtn && "0.5" }}
                            title={disableUploadBtn ? "Please select date range before uploading the file" : ""}
                        >
                            Upload File
                        </button>

                        <a href={require("../../assets/hubapprovedsob.xlsx")} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                            Download Sample Template
                        </a>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}

                    {overErrors.length > 0 && <div>
                        <p className="text-danger" style={{ fontSize: "15px", fontWeight: "bold", color: "#000" }}>Hub Over Percentage Errors</p>
                        {overErrors.map((err, i) => (
                            <div key={i} style={{ color: "#000" }}>
                                <b>{err.hub}:</b> {err.error}
                            </div>
                        ))}
                    </div>}

                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div className="" style={{ width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative", height: "100%" }}>
                                    <thead className="table-light text-center"
                                    // style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}
                                    >
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Upload only valid data" : "Upload"}
                    </button>
                </div>

            </div>

            <div className={`hub-slider ${editHubSOB.open ? "open" : ""} d-flex flex-column`} style={{ width: "590px", right: !editHubSOB.open && "-590px" }}>

                <div className="slider-header">
                    {`${editHubSOB.hub}`}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div
                    className="flex-grow-1"
                    style={{ overflowY: "auto" }}
                >
                    {editHubSOB.total > 100 && (
                        <p className="m-0 px-3 pt-3" style={{ color: "red", marginTop: "8px", backgroundColor: "#fff", position: "sticky", top: 0, zIndex: 1, left: 0 }}>
                            ⚠️ Total SOB must not be greater than 100%
                        </p>
                    )}
                    <div style={{ width: "100%", height: "100%" }} className="p-3 d-flex flex-column">
                        <table className="htu"
                            style={{
                                width: "100%",
                            }}
                        >
                            <thead>
                                <tr className="">
                                    <th style={{}}>
                                        Transporter Name
                                    </th>
                                    <th style={{}}>
                                        Transporter Code
                                    </th>
                                    <th style={{}}>
                                        {editHubSOB.hub}
                                    </th>
                                </tr>
                            </thead>

                            <tbody style={{ height: "250px", overflowY: "auto" }}>
                                {(editHubSOB.data || []).map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.transporter_name}</td>
                                        <td>{row.transporter_code}</td>
                                        <td className="d-flex justify-content-center">
                                            <input
                                                type="text"
                                                className="form-default"
                                                value={row[editHubSOB.hub] || ""}
                                                style={{ width: "100px", color: "blue" }}
                                                onChange={(e) => {
                                                    let value = e.target.value;

                                                    // ✅ Allow empty OR positive float
                                                    if (value === "" || /^\d*\.?\d*$/.test(value)) {

                                                        // ❌ prevent multiple dots like 1.2.3
                                                        if ((value.match(/\./g) || []).length > 1) return;

                                                        let updated = [...editHubSOB.data];
                                                        updated[index][editHubSOB.hub] = value;

                                                        // ✅ calculate total
                                                        let total = updated.reduce(
                                                            (sum, row) => sum + (parseFloat(row[editHubSOB.hub]) || 0),
                                                            0
                                                        );

                                                        setEditHubSOB(prev => ({
                                                            ...prev,
                                                            data: updated,
                                                            total
                                                        }));
                                                    }
                                                }}
                                                placeholder="0"
                                                // 🔥 Block invalid key presses
                                                onKeyDown={(e) => {
                                                    if (["-", "e", "E", "+"].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}

                                                // 🔥 Prevent invalid paste
                                                onPaste={(e) => {
                                                    const paste = e.clipboardData.getData("text");
                                                    if (!/^\d*\.?\d*$/.test(paste)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                            <tfoot>
                                <tr style={{

                                    zIndex: 2
                                }}>
                                    <td colSpan="2" className="text-center py-2"><b>Total</b></td>
                                    <td
                                        style={{

                                            zIndex: 2
                                        }} className="text-center py-2"
                                    >
                                        <b style={{ color: editHubSOB.total > 100 ? "red" : "green" }}>{editHubSOB.total} %</b>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", cursor: disableUpdate && "not-allowed", opacity: disableUpdate && "0.5" }}
                        onClick={onClickSOBUpdate}
                        disabled={disableUpdate}
                    >
                        {"Update"}
                    </button>
                </div>
            </div>

            {/* {controller.open && (
                <>
                    <div
                        className="slider-overlay"
                        onClick={() => { setController((prevState) => ({ ...prevState, open: false })) }}
                    />
                    <AddEditController
                        resource={controller}
                        onUpdate={onUpdateHubSOB}
                    />
                </>
            )} */}

            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>


        </div>
    );

};